import { Link } from "react-router-dom";
import Container from "@/components/base/Container";

export default function SubmitCta() {
  return (
    <section className="w-full bg-accent-500 py-14 md:py-16">
      <Container>
        <div className="flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              你手上也有一条没被理清的时间线？
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-800">
              把时间、地点与可核对的材料发给我们。截图、物料链接、现场记录都算，
              我们会先做脱敏处理，再决定它能不能进入下一步核查。
            </p>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto">
            <Link
              to="/about#submit"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-7 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </Link>
            <Link
              to="/faq"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/30 px-7 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950/10"
            >
              阅读投稿规则
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}